<template>
  <!-- 用户管理-设置主播 -->
  <div class="add_anchor-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-input style="width: 150px" clearable v-model.trim="formData.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select style="width: 150px" v-model="formData.type" placeholder="请选择类型">
            <el-option label="主播" :value="1"></el-option>
            <el-option label="领推广金UID" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addUser">添加</el-button>
        </el-form-item>
      </el-form>
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-input style="width: 150px" clearable v-model.trim="query.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select style="width: 150px" v-model="query.type" placeholder="请选择类型">
            <el-option label="全部" :value="undefined"></el-option>
            <el-option label="主播" :value="1"></el-option>
            <el-option label="领推广金UID" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData">查询</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-alert title="提示" :closable="false" style="font-size: 14px" type="warning"
        description="此主播与推广的主播不同，此主播用于对战房间标识" show-icon>
      </el-alert>
      <el-table :data="dataList" v-loading="loading" style="margin-bottom: 20px">
        <el-table-column prop="user_id" label="用户id" align="center">
        </el-table-column>
        <el-table-column prop="user_name" label="用户名称" align="center">
        </el-table-column>
        <el-table-column prop="type" label="类型" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.type == 1">主播</span>
            <span v-if="row.type == 2">领推广金UID</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="时间" min-width="150px" align="center" sortable>
        </el-table-column>
        <el-table-column prop="action" label="操作" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="danger" size="small" @click="deleteUser(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page" @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"></el-pagination>
    </div>

    <!-- 弹窗 -->
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import { patchData, postData, getApiData, patchApiData, postApiData, delApiData } from '@/http'

export default {
  name: 'add_anchor',
  components: {
  },
  data() {
    return {
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载数据动画
      query: {//查询条件
        page: 1,
        user_id: undefined,//用户id
        type: undefined,//主播类型 1是普通 2是领推广金UID
      },
      formData: {//添加用户
        user_id: undefined,//用户id
        type: 1,//主播类型 1是普通 2是领推广金UID
      },
      dataList: undefined,//数据列表
      dataMeta: undefined,//底部跳转页面条
    }
  },
  watch: {
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      //获取列表数据
      this.loading = true
      let params = this.query
      getApiData('settle_anchor', params).then(res => {
        if (res) {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = res
        }
      }).finally(() => {
        this.loading = false
      })
    },
    addUser() {
      //添加主播
      if (!this.formData.user_id) {
        this.$message.warning('请先输入用户id')
        return
      }
      let params = this.formData
      postApiData('settle_anchor', params).then(res => {
        this.$message.success('添加成功！')
        this.getData()
      })
    },
    deleteUser(rowInfo) {
      //删除主播
      let params = {
        id:rowInfo.id,
        user_id: rowInfo.user_id
      }
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`settle_anchor`, params).then(res => {
          this.$message.success('删除成功！')
          this.getData()
        })
      })

    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
.add_anchor-box {
  header {}

  .body-box {}
}
</style>